import React from 'react';
import { Box, Button, Flex, Heading, Stack, Spacer } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

import { ProfileField } from '../elements/ProfileField';
import { ProfileSelect } from '../elements/ProfileSelect';
import { relative } from '../data';
import { makeFields } from './utils';

export const Relative = ({ state, setter, remove, id, onBlur }) => {
	const {
		firstName,
		lastName,
		relationship,
		birthDate,
		deathDate,
		birthCountry,
		residenceCountry,
		city,
	} = makeFields(state, setter, relative, onBlur);
	return (
		<Box borderRadius="md" border="1px" borderColor="gray.200" p={4} mb={4}>
			<Flex>
				<Heading pb={6} fontSize={'lg'}>
					{state.firstName || 'Родственник'}
				</Heading>
				<Spacer />
				<Button
					leftIcon={<CloseIcon />}
					colorScheme="red"
					variant="solid"
					size="xs"
					name={id}
					onClick={remove}
				>
					Удалить
				</Button>
			</Flex>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...firstName} />
				<ProfileField pb={6} {...lastName} />
				<ProfileSelect pb={6} {...relationship} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...birthDate} />
				<ProfileField pb={6} {...deathDate} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileSelect pb={6} {...birthCountry} />
				<ProfileSelect pb={6} {...residenceCountry} />
				<ProfileField pb={6} {...city} />
			</Stack>
		</Box>
	);
};
